import useChatWindows from "@/hooks/useChatWindows";
import useLanguageConfigs from "@/pages/Messaging/WebMessenger/hooks/useLanguageConfigs";
import React from "react";
import { Link } from "react-router-dom";

export interface ChatWindowValue {
  chatWindow: string;
}

interface Props {
  updateValue: (value: ChatWindowValue) => void;
  value: ChatWindowValue;
}

export default function ChatWindowRuleForm({ value, updateValue }: Props) {
  const { chatWindows } = useChatWindows();

  if (!chatWindows || !chatWindows.length) {
    return (
      <>
        <span>{"You don't have any chat windows yet."}</span>
        <Link to="/chat_window">
          <button type="button" className="btn-link">
            Create one now.
          </button>
        </Link>
      </>
    );
  }

  return (
    <>
      <div>Set the conditions for when a chat window should be used.</div>
      <div className="flex flex-col mr-auto">
        <div>
          Select your chat window:
          <select
            className="flex flex-row input overflow-ellipsis whitespace-nowrap w-64 ml-2"
            value={value["chatWindow"]}
            onChange={(e) => updateValue({ chatWindow: e.currentTarget.value })}
          >
            <option value={""}>{"-- select a chat window --"}</option>
            {chatWindows.map((k, i) => (
              <option key={i} value={k.name}>
                {k.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
}
